(function(){
  if (window.__variantInquiryInit) return; window.__variantInquiryInit = true;

  function on(ev, fn, target){ (target||window).addEventListener(ev, fn, {passive:true}); }
  function qs(sel, root){ return (root||document).querySelector(sel); }
  function qsa(sel, root){ return Array.prototype.slice.call((root||document).querySelectorAll(sel)); }

  function patchHistory(){
    if (window.__locationPatched) return; window.__locationPatched = true;
    ['pushState','replaceState'].forEach(function(m){
      var orig = history[m];
      history[m] = function(){ var r = orig.apply(this, arguments); try{window.dispatchEvent(new Event('locationchange'));}catch(e){} return r; };
    });
    on('popstate', function(){ window.dispatchEvent(new Event('locationchange')); });
  }

  function getForm(root){
    return qs('form[action*="/cart/add"]', root) || qs('form.product-form', root) || qs('form[action*="/cart/add"]') || qs('form.product-form');
  }

  function getIdInput(root){
    var f = getForm(root); if (!f) return null;
    return f.querySelector('[name="id"]');
  }

  function variantIdFromForm(root){
    var i = getIdInput(root); return i && i.value ? String(i.value) : null;
  }

  function variantIdFromURL(){
    var s = new URLSearchParams(location.search), v = s.get('variant'); return v ? String(v) : null;
  }

  function getMap(root){
    var sid = root.getAttribute('data-section-id');
    var mapEl = qs('#variant-inquiry-map-'+sid, root);
    if (!mapEl) return {};
    try { return JSON.parse(mapEl.textContent || '{}'); } catch(e){ return {}; }
  }

  function toggle(root, id){
    var sid = root.getAttribute('data-section-id');
    var inquiryEl  = qs('#variant-inquiry-'+sid, root);
    var purchaseEl = qs('#purchase-main-'+sid, root);
    if (!inquiryEl || !purchaseEl) return;
    var map = root.__vi_map || (root.__vi_map = getMap(root));
    var show = !!(id && map[id]);
    if (inquiryEl.style.display !== (show ? 'block' : 'none')) inquiryEl.style.display = show ? 'block' : 'none';
    if (purchaseEl.style.display !== (show ? 'none' : 'block')) purchaseEl.style.display = show ? 'none' : 'block';
  }

  function readCurrentId(root){
    return variantIdFromForm(root) || variantIdFromURL();
  }

  function wire(root){
    if (!root || root.__vi_wired) return; root.__vi_wired = true;

    function refreshMap(){ root.__vi_map = getMap(root); }
    refreshMap();

    function recalc(){
      var id = readCurrentId(root);
      if (id && id !== root.__vi_lastId){ root.__vi_lastId = id; toggle(root, id); }
      if (!id) toggle(root, null);
    }

    var f = getForm(root);
    if (f){
      f.addEventListener('change', function(e){
        if (e.target && e.target.name === 'id') recalc();
      });
    }

    var mo = new MutationObserver(function(muts){
      var touch = false, mapTouched = false;
      for (var i=0;i<muts.length;i++){
        var m = muts[i];
        if (m.type === 'childList'){
          if (Array.prototype.some.call(m.addedNodes, function(n){ return n.nodeType===1 && (n.matches && (n.matches('[name="id"], form, .product, .product__form') || n.querySelector && n.querySelector('[name="id"]'))); })){
            touch = true;
          }
          if (Array.prototype.some.call(m.addedNodes, function(n){ return n.nodeType===1 && (n.id && n.id.indexOf('variant-inquiry-map-')===0); })){
            mapTouched = true;
          }
        }
        if (m.type === 'attributes' && m.target && m.target.nodeType===1){
          if (m.target.getAttribute && m.target.getAttribute('name')==='id') touch = true;
        }
      }
      if (mapTouched) refreshMap();
      if (touch){ f = getForm(root); recalc(); }
    });

    mo.observe(root, {subtree:true, childList:true, attributes:true, attributeFilter:['value','name']});
    root.__vi_mo = mo;

    var idInput = getIdInput(root);
    if (idInput){
      var moId = new MutationObserver(function(){ recalc(); });
      moId.observe(idInput, {attributes:true, attributeFilter:['value']});
      root.__vi_moId = moId;
    }

    var poller = setInterval(function(){
      var id = readCurrentId(root);
      if (id !== root.__vi_lastId){ root.__vi_lastId = id; toggle(root, id); }
    }, 250);
    root.__vi_poller = poller;

    recalc();
  }

  function initAll(){
    qsa('.variant-inquiry-root').forEach(wire);
  }

  function afterSectionEvent(e){
    var id = e && e.detail && e.detail.sectionId;
    if (!id) return initAll();
    var root = qs('.variant-inquiry-root[data-section-id="'+id+'"]');
    if (root){ root.__vi_wired = false; wire(root); }
  }

  patchHistory();
  on('DOMContentLoaded', initAll, document);
  if (document.readyState !== 'loading') initAll();

  on('locationchange', initAll);
  on('variant:change', initAll, document);
  on('shopify:variant:change', initAll, document);
  on('shopify:section:load', afterSectionEvent, document);
  on('shopify:section:select', afterSectionEvent, document);
})();
